import script from "./ai-detail-talk-mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-detail-talk-mobile.vue?vue&type=script&setup=true&lang=js"

import "./ai-detail-talk-mobile.vue?vue&type=style&index=0&id=7041cbd9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7041cbd9"]])

export default __exports__